import { render, staticRenderFns } from "./FormWizardIcon.vue?vue&type=template&id=95130112"
import script from "./FormWizardIcon.vue?vue&type=script&lang=js"
export * from "./FormWizardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports